import { render } from "./ContainerView.vue?vue&type=template&id=ef79d07a"
import script from "./ContainerView.vue?vue&type=script&lang=js"
export * from "./ContainerView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__